import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { clienteCadastros } from '../cliente-cadastro';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-cliente-cadastro-multiselect',
    templateUrl: './cliente-cadastro-multiselect.component.html',
    styleUrls: ['./cliente-cadastro-multiselect.component.less']
})
export class ClienteCadastroMultiselectComponent implements OnInit {
    /** Cadastros dos clientes selecionados */
    @Input() cadastros: number[];
    /** Ao alterar a seleção dos cadastros dos clientes */
    @Output() cadastrosChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Cadastro';
    @Input() checked = 'Cadastro';
    @Input() checkedPlural = 'Cadastros';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum cadastro encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-cliente-cadastro ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os cadastros dos clientes para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        clienteCadastros.forEach(cadastro => {
            selects.push({
                id: cadastro.id,
                name: cadastro.nome,
            });
        });
        this.options = selects;
    }

    /** Ao alterar a seleção dos cadastros dos clientes */
    onChange() {
        this.cadastrosChange.emit(this.cadastros);
    }
}
